<template>
  <div class="layout">
    <Layout>
      <AdminHeader />
      <Layout>
        <Sider hide-trigger :style="{background: '#fff'}">
          <AdminLeftMenu />
          <div class="slider-sep"></div>
        </Sider>
        <Layout class="admin-right-wrap">
          <AdminContentBread />
          <!--页面内容主体开始-->
          <Content class="admin-wrap">
            <div class="member-info-opt-wrap"><Button type="primary" @click="edit">修改会员信息</Button></div>
            <div class="member-info-wrap">
              <Row class="member-info-content">
                <Col span="2" class="member-info-prefix">会员姓名：</Col>
                <Col span="22" class="member-info-suffix">{{memberInfo.memberName}}</Col>
              </Row>
              <Row class="member-info-content">
                <Col span="2" class="member-info-prefix">会员性别：</Col>
                <Col span="22" class="member-info-suffix">{{memberInfo.memberGender}}</Col>
              </Row>
              <Row class="member-info-content">
                <Col span="2" class="member-info-prefix">联系电话：</Col>
                <Col span="22" class="member-info-suffix">{{memberInfo.memberTel}}</Col>
              </Row>
              <Row class="member-info-content">
                <Col span="2" class="member-info-prefix">职称：</Col>
                <Col span="22" class="member-info-suffix">{{memberInfo.memberTitle}}</Col>
              </Row>
              <Row class="member-info-content">
                <Col span="2" class="member-info-prefix">所属机构：</Col>
                <Col span="22" class="member-info-suffix">{{memberInfo.associationName}}</Col>
              </Row>
              <Row class="member-info-content">
                <Col span="2" class="member-info-prefix">工作单位：</Col>
                <Col span="22" class="member-info-suffix">{{memberInfo.workUnit}}</Col>
              </Row>
              <Row class="member-info-content">
                <Col span="2" class="member-info-prefix">年龄段：</Col>
                <Col span="22" class="member-info-suffix">{{memberInfo.ageGroup}}</Col>
              </Row>
              <Row class="member-info-content">
                <Col span="2" class="member-info-prefix">出生日期：</Col>
                <Col span="22" class="member-info-suffix">{{memberInfo.birthday}}</Col>
              </Row>
              <Row class="member-info-content">
                <Col span="2" class="member-info-prefix">入会日期：</Col>
                <Col span="22" class="member-info-suffix">{{memberInfo.joindate}}</Col>
              </Row>
              <Row class="member-info-content">
                <Col span="2" class="member-info-prefix">民族：</Col>
                <Col span="22" class="member-info-suffix">{{memberInfo.memberNation}}</Col>
              </Row>
              <Row class="member-info-content">
                <Col span="2" class="member-info-prefix">出生地：</Col>
                <Col span="22" class="member-info-suffix">{{memberInfo.memberNative}}</Col>
              </Row>
              <Row class="member-info-content">
                <Col span="2" class="member-info-prefix">会员状态：</Col>
                <Col span="22" class="member-info-suffix">{{memberInfo.status}}</Col>
              </Row>
              <Row class="member-info-content">
                <Col span="2" class="member-info-prefix">会员介绍：</Col>
                <Col span="22" class="member-info-suffix">{{memberInfo.memberDesc}}</Col>
              </Row>
            </div>
          </Content>
          <!--页面内容主体结束-->
        </Layout>
      </Layout>
    </Layout>
  </div>
</template>
<script>
import axios from "axios"
import AdminLeftMenu from '@/components/AdminLeftMenu.vue'
import AdminContentBread from '@/components/AdminContentBread.vue'
import AdminHeader from '@/components/AdminHeader.vue'
export default {
  components: {
    AdminLeftMenu,
    AdminContentBread,
    AdminHeader
  },

  //数据
  data() {
    return {
      token: '',
      memberInfo: {}
    }
  },

  //加载后执行
  mounted() {
    //初始化页面数据
    this.initAuthData()

    //获取会员列表
    this.getMemberInfo()
  },
  
  //自定义函数
  methods: {
    //初始化页面基础信息
    initAuthData() {
      let admin = JSON.parse(localStorage.getItem("adminInfo"));
      if(admin!=null) {
        this.token = admin.token
      }
    },

    //获取会员列表
    getMemberInfo() {
      let vm = this
      let memberId = parseInt(vm.$route.query.id)
      axios.post(
        vm.GLOBAL_API.apiUrl + "/manage/members/info-get-for-show",
        {memberId: memberId, status: 1},
        {
          headers: {
            'content-type': 'application/json',
            "Authorization": "Bearer " + vm.token
          }
        }
      ).then(function(res) {
        let info = res.data
        vm.memberInfo = info.data
        //console.log(info.data)
      }).catch(function(error) {
        console.log(error)
      });
    },

    //会员编辑
    edit() {
      window.open(this.$router.resolve({ path: '/manage/members/edit', query: { id: this.memberInfo.memberId }}).href)
    }

  }
}
</script>